import React from 'react';
import { useInscriptionConversation, type InscriptionKind } from '../../hooks/useInscriptionConversation';
import { AtnaDialogShell } from '../atna/AtnaDialogShell';
import { InscriptionMessage } from './InscriptionMessage';
interface InscriptionDialogProps {
  initialText: string;
  onClose: () => void;
  /** Shared layout id: the launcher pill morphs into this panel. */
  layoutId: string;
}
export function InscriptionDialog({
  initialText,
  onClose,
  layoutId
}: InscriptionDialogProps) {
  const {
    turns,
    thinking,
    draft,
    setDraft,
    submitDraft,
    category,
    slots,
    slot,
    newAllergy,
    pickCategory,
    register,
    confirmAllergies,
    restart,
    liveAtnaId,
    lastAtnaKind
  } = useInscriptionConversation(initialText);
  return <AtnaDialogShell layoutId={layoutId} subtitle="Inscription aux activités" onClose={onClose} turns={turns} thinking={thinking} liveAtnaId={liveAtnaId} footnote="ATNA peut se tromper. Vérifiez l’horaire avant de confirmer une inscription." satisfaction={lastAtnaKind === 'confirmation'} prompt={{
    value: draft,
    onChange: setDraft,
    onSubmit: submitDraft,
    placeholder: lastAtnaKind === 'confirmation' ? 'Inscrire à une autre activité ?' : lastAtnaKind === 'allergies' ? 'Ex. « allergie au pollen, antihistaminique au besoin »…' : 'Nommez une activité, ex. « cours de piscine »…'
  }} renderAtna={(kind, live) => <InscriptionMessage kind={kind as InscriptionKind} live={live} category={category} slots={slots} slot={slot} newAllergy={newAllergy} onPickCategory={pickCategory} onRegister={register} onConfirmAllergies={confirmAllergies} onRestart={restart} data-id="element-2028" data-mp="nbi1k2b5peje" />} data-id="element-2027" data-mp="2fx4t573hs0tp" />;
}